import type { BasePageData } from '@/types'

export enum MedComplexStatusEnum {
  ACTIVE = 'ACTIVE', // 'IN_PROGRESS',
  INACTIVE = 'INACTIVE',
  BLOCKED = 'BLOCKED',
  INNER_BLOCKED = 'INNER_BLOCKED',
  DRAFT = 'DRAFT',
}

export enum CertificateStatusEnum {
  ACTIVE = 'ACTIVE',
  ARHIVED = 'ARHIVED',
}

export interface MedComplexList extends BasePageData {
  data: MedComplex[]
}

export interface CertificateCheckInfoList {
  data: CertificateCheckInfo[]
}

// export interface MedComplexModelList {
//   data: MedComplexModel[]
// }

export interface MedComplex {
  id?: number
  model?: MedComplexModel
  modelId?: number
  complex_serial_number?: string
  bluetooth_serial_number?: string
  date_creation?: string
  guarantee_period?: string
  ownerCompanyId?: number
  clientCompaniesIds?: number[]
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  ownerCompany?: any
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  clientCompanies?: any
  status?: {
    slug: MedComplexStatusEnum
  }
  certificates?: MedComplexCertificate[]
  certificate_status?: string
  model_name?: string
  type?: string
  date_expiration?: string
  is_connected?: boolean
  is_blocked?: boolean
  humidity_upper?: string | number
  humidity_lower?: string | number
  luminosity_upper?: string | number
  luminosity_lower?: string | number
  temp_upper?: string | number
  temp_lower?: string | number
  logs?: string
  record_slides?: boolean | null
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  gmt?: any | null
  adress?: string | null
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  clientCompany?: any
}

export interface MedComplexModel {
  id: number
  name: string
  type: string
  medComplex: MedComplex[]
}

export interface MedComplexCertificate {
  id?: number
  date_inspection: string
  date_expiration: string
  serial_number: string
  files?: MedComplexCertificateFiles[]
  medComplex?: MedComplex
  status?: {
    slug: CertificateStatusEnum
  }
}

export interface MedComplexCertificateFiles {
  id: number
  url: string
  ext_file_id: string
}

export interface MedComplexQueryParams {
  query?: string
}

export interface CertificateCheckInfo {
  id?: number
  status?: {
    id?: number
    name?: string
    slug?: string
    createdAt?: string
    updatedAt?: string
  }
  complex_serial_number?: string
  bluetooth_serial_number?: string
  date_expiration?: string
  message?: string
  days_left?: string
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  icon?: any
}
